export const isDarwin =
  typeof navigator != "undefined" ? /mac|iphone|ipad/.test(navigator.platform.toLocaleLowerCase()) : false;
